import { apiFetch } from "./api-client";
import type { ReadStat } from "./fingerspelling-weak";

/** 自分の「よむ」の文字別記録（全文字分）を取得する */
export const fetchReadStats = (): Promise<ReadStat[]> =>
  apiFetch<ReadStat[]>("/fingerspelling/read-stats");

/** 送信中の回答。記録を取り直す前に、これが終わるのを待つ */
const pendingAnswers = new Set<Promise<void>>();

/**
 * 1問分の回答結果を記録する。
 * 電波が切れているなどで失敗したときは、記録せずに捨てる（例外も画面表示も出さない）。
 */
export const postReadAnswer = (
  entryId: string,
  correct: boolean,
): Promise<void> => {
  const sending = apiFetch("/fingerspelling/read-stats", {
    method: "POST",
    body: JSON.stringify({ entryId, correct }),
  })
    .then(() => undefined)
    .catch(() => undefined)
    .finally(() => pendingAnswers.delete(sending));
  pendingAnswers.add(sending);
  return sending;
};

/** 送信中の回答がすべて終わる（成功・失敗は問わない）まで待つ */
export const flushPendingAnswers = async (): Promise<void> => {
  await Promise.allSettled([...pendingAnswers]);
};
